export default {
  'notification.empty': 'You have viewed all notifications',
  'notification.mark_all_as_read': 'Mark All as Read',
  'notification.clear_all': 'Clear All',
  'notification.load.more': 'Load More',
  'notification.message.approval.approved': 'The {module} submitted has been approved',
  'notification.message.approval.submitted': 'A new {module} needs approval',
  'notification.message.approval.rejected': 'The {module} submitted has been rejected',
  'notification.message.statement.added_fapiao': 'A new fapiao has been added to statement {code}',
  'notification.message.statement.approved': 'The statement {code} has been approved',
  'notification.message.payment_plan.approved': 'The payment plan {code} has been approved',
  'notification.message.arap.import.success': 'AR/AP import successful!',
  'notification.message.arap.import.error': 'AR/AP import failed!',
  'notification.message.shipment.import.success': 'Shipment import successful!',
  'notification.message.shipment.import.error': 'Shipment import failed!',
  'notification.message.update.available': 'New version available',
  'notification.message.update.refresh': 'Refresh',
  'notification.message.shipment.update': 'Shipment {shipment_number} has been updated',
  'notification.message.inbox_item.pre_alert': 'Pre-alert: {subject}',
  'notification.pre_alert.done': 'Done: {items}',
  'notification.pre_alert.review': '{count} to review',
  'notification.pre_alert.add_shipment_documents': 'documents attached',
  'notification.pre_alert.update_shipment': 'shipment updated',
  'notification.pre_alert.create_shipment': 'shipment created',
  'notification.pre_alert.unmatched': 'Contacts to fill in: {parties}',
  'notification.pre_alert.party.shipper': 'Shipper',
  'notification.pre_alert.party.consignee': 'Consignee',
  'notification.pre_alert.party.notify': 'Notify party',
  'notification.message.rate.import.success': 'Rate import successful!',
  'notification.message.rate.import.error': 'Rate import failed!',
  'notification.message.task.process_excel_file.error': 'Error processing excel file',
  'notification.message.task.process_excel_file.success': 'Excel file processed successfully',
  'notification.message.paymentplan.import.success': 'Payment plan import successful!',
  'notification.message.paymentplan.import.error': 'Payment plan import failed!',
  'notification.message.statement.import.success': 'Statement import successful!',
  'notification.message.statement.import.error': 'Statement import failed!',
};
